import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { shopsActions } from '../../actions';
import {
  entriesSelector, showOnMapSelector,
  viewAllShopsSelector, directionModeSelector,
  userAddressSelector, searchQuerySelector, selectedTravelModeSelector,
} from '../../selectors/shops';
import Select from '../../../ui_kit/select/Select';
import mapServices from '../../services/mapService';
import styles from './MapWithStores.module.sass';

const DESKTOP_WIDTH_BREAKPOINT = 700;
const SELECT_OPTIONS = [
  { label: 'DRIVING', value: 'DRIVING' },
  { label: 'WALKING', value: 'WALKING' },
  { label: 'BICYCLING', value: 'BICYCLING' },
  { label: 'TRANSIT', value: 'TRANSIT' },
];

class MapWithStores extends Component {
  componentDidMount() {
    const { shops } = this.props;
    window.mapService = new mapServices.MapService('shops-map', shops);
    window.mapService.init();
    this.addForceUpdateShowOnMapListener();
    this.addDirectionClickListener();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.forceUpdateShowOnMap);
    window.removeEventListener('build_direction', this.onDirectionClick);
  }

  forceUpdateShowOnMap = () => {
    const { setShowOnMap } = this.props;

    if (window.innerWidth >= DESKTOP_WIDTH_BREAKPOINT) {
      setShowOnMap(true);
    }
  };

  addForceUpdateShowOnMapListener = () => {
    window.addEventListener('resize', this.forceUpdateShowOnMap);
  };

  onDirectionClick = (event) => {
    const {
      setDirectionMode, setDirectionTo, setSearchQuery,
    } = this.props;
    const { mapService } = window;
    const { shops, searchQuery, userAddress } = this.props;
    const [directionTo] = shops.filter((shop) => shop.id === event.detail);
    window.directionTo = directionTo;
    setDirectionTo(directionTo);
    setDirectionMode(true);
    mapService.enableDirectionMode();
    if (userAddress && !searchQuery) {
      setSearchQuery(userAddress);
      mapService.buildRoute(userAddress);
    }
    if (searchQuery) {
      mapService.buildRoute(searchQuery);
    }
  };

  addDirectionClickListener = () => {
    window.addEventListener('build_direction', this.onDirectionClick);
  };

  onChangeTravelMode = (event) => {
    const { mapService } = window;
    const { searchQuery, setTravelMode } = this.props;
    const newTravelMode = event.target.value;
    setTravelMode(newTravelMode);

    mapService.buildRoute(searchQuery, newTravelMode);
  };

  render() {
    const {
      showOnMap, viewAllShops, directionMode, selectedTravelMode,
    } = this.props;

    return (
      <div id="shops-map" className={styles.map} style={(directionMode || (showOnMap && !viewAllShops)) ? {} : { display: 'none' }}>
        { directionMode && (
          <div className={styles.mode}>
            <span>Mode of Travel: </span>
            <Select
              name="Mode to Travel"
              value={selectedTravelMode}
              options={SELECT_OPTIONS}
              onChange={this.onChangeTravelMode}
            />
          </div>
        )}
      </div>
    );
  }
}

MapWithStores.propTypes = {
  shops: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showOnMap: PropTypes.bool.isRequired,
  viewAllShops: PropTypes.bool.isRequired,
  setShowOnMap: PropTypes.func.isRequired,
  setDirectionMode: PropTypes.func.isRequired,
  setDirectionTo: PropTypes.func.isRequired,
  directionMode: PropTypes.bool.isRequired,
  userAddress: PropTypes.string,
  searchQuery: PropTypes.string,
  selectedTravelMode: PropTypes.string.isRequired,
  setTravelMode: PropTypes.func.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  shops: entriesSelector(state),
  showOnMap: showOnMapSelector(state),
  viewAllShops: viewAllShopsSelector(state),
  directionMode: directionModeSelector(state),
  userAddress: userAddressSelector(state),
  searchQuery: searchQuerySelector(state),
  selectedTravelMode: selectedTravelModeSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setShowOnMap: (showOnMap) => { dispatch(shopsActions.setShowOnMap(showOnMap)); },
  setDirectionMode: (directionMode) => {
    dispatch(shopsActions.setDirectionMode(directionMode));
  },
  setDirectionTo: (directionTo) => {
    dispatch(shopsActions.setDirectionTo(directionTo));
  },
  setTravelMode: (selectedTravelMode) => {
    dispatch(shopsActions.setTravelMode(selectedTravelMode));
  },
  setSearchQuery: (searchQuery) => {
    dispatch(shopsActions.setSearchQuery(searchQuery));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MapWithStores);
